import { useCalendarStore } from "@/pages/Dashboard/Calendar/store/useCalendarStore";
import {
  resolveStaffRequestIndicatorVisible,
  useCustomerStaffRequestEnabled,
} from "@/hooks/useCustomerStaffRequestEnabled";

export function useStaffRequestIndicatorVisible(): boolean {
  const isCustomerStaffRequestEnabled = useCustomerStaffRequestEnabled();
  // Selected rather than pulling the whole store: every calendar block calls
  // this, and an unselected subscription re-renders all of them on any store
  // change.
  const locationStaffCount = useCalendarStore(
    (state: { locationStaffCount?: number | null }) => state.locationStaffCount,
  );

  return resolveStaffRequestIndicatorVisible({
    isCustomerStaffRequestEnabled,
    locationStaffCount,
  });
}
